import React, { useContext, useEffect, useState } from 'react';
import DashboardNotifications from './DashboardNotifications';
import Carousel from '../../components/Carousel';
import TutorialPrompt from '../../components/Tutorial/TutorialPrompt';
import Axios from 'axios';
import { CurrentTeamContext } from '../../contexts/CurrentTeamContext';
import { NotificationContext } from '../../contexts/NotificationContext';
import config from '../../config';
import Loading from '../../components/Loading/Loading';
import { CurrentUserContext } from '../../contexts/CurrentUserContext';
import Cookies from 'js-cookie';
import TeamChooseModal from '../../components/Modals/TeamChooseModal';
import Overlay from '../../components/Overlay';
import useFetch from '../../hooks/useFetch';
import Signposts from '../../components/Signposts';
import DefaultBanner from '../../components/Banners/DefaultBanner';
import UiVersionBanner from '../../components/Banners/UiVersionBanner';

export default function Dashboard() {
	const [loaded, setLoaded] = useState(false);
	const [suppliers, setSuppliers] = useState([]);
	const [ordersCount, setOrdersCount] = useState();
	const [notificationsCount, setNotificationsCount] = useState();
	let { getNewTokens } = useContext(CurrentUserContext);
	let { teamState, teamDispatch } = useContext(CurrentTeamContext);
	let { notificationsState } = useContext(NotificationContext);

	const { data, reqLoading } = useFetch(`${config.apiv1}/team/team.read/trusted/${teamState.currentTeam.teamUuid}`);

	const ZERO_ORDER_COUNTS = {
		drafts: 0,
		purchasesPending: 0,
		purchasesAccepted: 0,
		purchasesProcessing: 0,
		purchasesDispatched: 0,
		purchasesHeld: 0,
		salesPending: 0,
		salesAccepted: 0,
		salesProcessing: 0,
		awaitingDispatch: 0,
		salesDispatched: 0,
		salesCompleted: 0,
		salesHeld: 0,
	};

	useEffect(() => {
		var cancelled = false;

		var teamUuid =
			teamState && teamState.currentTeam && teamState.currentTeam.teamUuid
				? teamState.currentTeam.teamUuid
				: null;

		if (!teamUuid) return;

		function setSafeCounts(payload) {
			if (cancelled) return;

			// endpoint returns: { ok, status, message, data: { ...counts } }
			var counts = payload && payload.data ? payload.data : null;

			if (!counts) counts = ZERO_ORDER_COUNTS;

			// normalize in case backend ever misses a key
			var normalized = Object.assign({}, ZERO_ORDER_COUNTS, counts);

			setOrdersCount(normalized);
			setLoaded(true);
		}

		async function fetchOrderStats(hasRetried) {
			try {
				var res = await Axios({
					url: config.apiv1 + '/order/orders.statuses/' + teamUuid,
					method: 'GET',
				});

				if (!res || !res.data) {
					setSafeCounts(null);
					return;
				}

				setSafeCounts(res.data);
			} catch (err) {
				var status = err && err.response ? err.response.status : null;

				if (!hasRetried && status === 401 && typeof getNewTokens === 'function') {
					try {
						await getNewTokens();
						if (!cancelled) await fetchOrderStats(true);
						return;
					} catch (e) {
						// fall through
					}
				}

				setSafeCounts(null);
			}
		}

		fetchOrderStats(false);

		return function () {
			cancelled = true;
		};
	}, [teamState?.currentTeam?.teamUuid, getNewTokens]);

	return (
		<>
			{loaded ? (
				<>
					<UiVersionBanner />
					<Signposts />
					<div className='mainOverview'>
						<DashboardNotifications ordersCount={ordersCount} notificationsCount={notificationsCount} />
					</div>
					<Carousel
						headerType={'suppliers'}
						backColor={'gray-200'}
						type={'suppliers'}
						loaded={!reqLoading}
						customList={data}
						mode={'light'}
					/>
					<Carousel
						backColor={'learningZoneBack'}
						type={'learningZone'}
						headerType={'learningZone'}
						mode={'dark'}
					/>
					<TutorialPrompt page='dashboard' />
				</>
			) : (
				<Loading type={'circle'} />
			)}
		</>
	);
}
